<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24 add-user-to-team-container" fxLayout="column" fxLayoutAlign="start">
    <ng-container *ngIf="selectedUsersSet.size">
        <h3 class="my-12 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
        <mat-chip-set class="mb-12 wrap">
            <mat-chip class="accent-500" (removed)="onDeselect(user)" *ngFor="let user of selectedUsersSet; let i = index">
                {{ user.fullName }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
        <app-search-outline [searchInput]="searchInput"></app-search-outline>
    </div>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="add-user-to-team-tree border pr-0" *ngIf="!searchInput.value">
        <!-- This is the tree node template for leaf nodes -->
        <!-- There is inline padding applied to this node using styles.
          This padding value depends on the mat-icon-button width. -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <div fxLayout="column" class="w-100-p">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p p-16 pr-24">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <button mat-icon-button class="mr-8" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" (click)="getTeamUsers(node)" [disabled]="dataFetched">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>
                        <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                            <mat-icon svgIcon="team"></mat-icon>
                        </div>
                        <h3>{{ node.name }}</h3>
                    </div>
                </div>

                <!-- There is inline padding applied to this div using styles.
                    This padding value depends on the mat-icon-button width.  -->
                <div class="white" [class.add-user-to-team-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                    <div *ngIf="!node.isLoading; else spinner">
                        <mat-table class="team-users-table-wrapper" [dataSource]="node.users" *ngIf="node.users?.length">
                            <!-- Avatar Column -->
                            <ng-container matColumnDef="avatar">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let user">
                                    <div #avatarCell>
                                        <img *ngIf="user.avatar.src; else initials" class="avatar mr-0 mr-sm-16" [src]="user.avatar.src" />
                                        <ng-template #initials>
                                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                        </ng-template>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- Full Name Column -->
                            <ng-container matColumnDef="name">
                                <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                                <mat-cell *matCellDef="let user" class="narrow">
                                    <p #name class="text-truncate font-semibold">
                                        {{ user.fullName }}
                                    </p>
                                </mat-cell>
                            </ng-container>

                            <!-- Last Name Column -->
                            <ng-container matColumnDef="role">
                                <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                                    {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let user" class="narrow">
                                    <p #role class="text-truncate">
                                        <span *ngFor="let userTeamRole of user.teamRoles; let last = last">
                                            {{ userTeamRole | getStatus: UserTeamRoles:'translationLabel' | translate }}{{ !last ? ', ' : '' }}
                                        </span>
                                    </p>
                                </mat-cell>
                            </ng-container>

                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                                <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                                    {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let user" class="wider" fxHide fxShow.gt-xs>
                                    <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                                </mat-cell>
                            </ng-container>

                            <!-- Buttons Column -->
                            <ng-container matColumnDef="buttons">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let user">
                                    <div fxFlex="row" fxLayoutAlign="end center">
                                        <p *ngIf="user.alreadyMember; else selectUser">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>

                                        <ng-template #selectUser>
                                            <app-flat-button
                                                [label]="'GENERAL.BUTTON.ADD'"
                                                (onClick)="onSelect(user)"
                                                *ngIf="!isUserSelected(user); else unselect"
                                            ></app-flat-button>

                                            <ng-template #unselect>
                                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(user)"></app-white-button>
                                            </ng-template>
                                        </ng-template>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
                        </mat-table>
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                    <ng-template #spinner>
                        <div class="p-24 white" fxLayout="column" fxLayoutAlign="center center">
                            <mat-spinner diameter="24"></mat-spinner>
                        </div>
                    </ng-template>
                </div>
            </div>
        </mat-tree-node>

        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-16 pr-24">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-8" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" (click)="getTeamUsers(node)" [disabled]="dataFetched">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                    </button>
                    <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                        <mat-icon svgIcon="team"></mat-icon>
                    </div>
                    <h3>{{ node.name }}</h3>
                </div>
            </div>
            <!-- There is inline padding applied to this div using styles.
                This padding value depends on the mat-icon-button width.  -->
            <div [class.add-user-to-team-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                <div *ngIf="!node.isLoading; else spinner">
                    <mat-table class="team-users-table-wrapper" [dataSource]="node.users" *ngIf="node.users?.length">
                        <!-- Avatar Column -->
                        <ng-container matColumnDef="avatar">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let user">
                                <div #avatarCell>
                                    <img *ngIf="user.avatar.src; else initials" class="avatar mr-0 mr-sm-16" [src]="user.avatar.src" />
                                    <ng-template #initials>
                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                    </ng-template>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <!-- Full Name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                            <mat-cell *matCellDef="let user" class="narrow">
                                <p #name class="text-truncate font-semibold">
                                    {{ user.fullName }}
                                </p>
                            </mat-cell>
                        </ng-container>

                        <!-- Last Name Column -->
                        <ng-container matColumnDef="role">
                            <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                                {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let user" class="narrow">
                                <p #role class="text-truncate">
                                    <span *ngFor="let userTeamRole of user.teamRoles; let last = last">
                                        {{ userTeamRole | getStatus: UserTeamRoles:'translationLabel' | translate }}{{ !last ? ', ' : '' }}
                                    </span>
                                </p>
                            </mat-cell>
                        </ng-container>

                        <!-- Email Column -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                                {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let user" class="wider" fxHide fxShow.gt-xs>
                                <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                            </mat-cell>
                        </ng-container>

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="buttons">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let user">
                                <div fxFlex="row" fxLayoutAlign="end center">
                                    <p *ngIf="user.alreadyMember; else selectUser">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>

                                    <ng-template #selectUser>
                                        <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="onSelect(user)" *ngIf="!isUserSelected(user); else unselect"></app-flat-button>

                                        <ng-template #unselect>
                                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(user)"></app-white-button>
                                        </ng-template>
                                    </ng-template>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
                    </mat-table>
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
                <ng-template #spinner>
                    <div class="p-24 white" fxLayout="column" fxLayoutAlign="center center">
                        <mat-spinner diameter="24"></mat-spinner>
                    </div>
                </ng-template>
            </div>
        </mat-nested-tree-node>
    </mat-tree>

    <div class="teams-users-table-wrapper relative border white" [class.hidden]="!searchInput.value">
        <mat-table #table [dataSource]="teamsUsersDataSource" *ngIf="teamsUsersDataSource">
            <!-- Avatar Column -->
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div #avatarCell>
                        <img *ngIf="user.avatar.src; else initials" class="avatar mr-0 mr-sm-16" [src]="user.avatar.src" />
                        <ng-template #initials>
                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                        </ng-template>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- First Name Column -->
            <ng-container matColumnDef="firstName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }} </mat-header-cell>
                <mat-cell class="user-details-card-container" *matCellDef="let user">
                    <p #firstNameRow class="text-truncate font-semibold pointer">{{ user.firstName }}</p>
                </mat-cell>
            </ng-container>

            <!--Last Name Column -->
            <ng-container matColumnDef="lastName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.LAST_NAME' | translate }} </mat-header-cell>
                <mat-cell class="user-details-card-container" *matCellDef="let user">
                    <p #lastNameRow class="text-truncate font-semibold pointer">{{ user.lastName }}</p>
                </mat-cell>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                    {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user" class="wider" fxHide fxShow.gt-xs>
                    <p #emailRow class="text-truncate font-semibold">{{ user.email }}</p>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <p *ngIf="user.alreadyMember; else selectUser">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>

                        <ng-template #selectUser>
                            <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="onSelect(user)" *ngIf="!isUserSelected(user); else unselect"></app-flat-button>

                            <ng-template #unselect>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(user)"></app-white-button>
                            </ng-template>
                        </ng-template>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="teamsUsersDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let user; columns: teamsUsersDisplayedColumns" class="user" matRipple> </mat-row>
        </mat-table>
        <mat-paginator persistPageSize="teams.add-user-to-team-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"> </mat-paginator>

        <div class="p-24 spinner-wrapper" fxLayout="column" fxLayoutAlign="center center" *ngIf="isFetching$ | async">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>

<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button [disabled]="!selectedUsersSet.size" [label]="'GENERAL.LABEL.CLEAR_SELECTION'" (onClick)="onClearSelection()"></app-white-button>
    <mat-slide-toggle class="ml-24" *ngIf="role === 'teamLeader'" [(ngModel)]="assignAsTrainingResponsible">
        {{ 'TEAMS.LEAD.TOGGLE.ASSIGN_AS_TRAINING_APPROVER' | translate }}
    </mat-slide-toggle>
    <div class="example-spacer"></div>
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onSave()" [disabled]="!selectedUsersSet.size"></app-flat-button>
</div>
